import * as React from 'react';
import TableContext from '../context/TableContext';
import Summary from './Summary';
export const SummaryContext = React.createContext({});
function Footer({ children, stickyOffsets, flattenColumns }) {
    const tableContext = React.useContext(TableContext);
    const { prefixCls } = tableContext;
    const lastColumnIndex = flattenColumns.length - 1;
    const scrollColumn = flattenColumns[lastColumnIndex];
    const summaryContext = React.useMemo(() => ({
        stickyOffsets,
        flattenColumns,
        scrollColumnIndex: (scrollColumn === null || scrollColumn === void 0 ? void 0 : scrollColumn.scrollbar) ? lastColumnIndex : null
    }), [scrollColumn, flattenColumns, lastColumnIndex, stickyOffsets]);
    return (<SummaryContext.Provider value={summaryContext}>
            <tfoot className={`${prefixCls}-summary`}>{children}</tfoot>
        </SummaryContext.Provider>);
}
export default Footer;
export const FooterComponents = Summary;
